import { FC } from 'react';
import { useMedia } from 'react-use';

import { BlockHeader, Button, Container } from '../../../../../shared/lib/ui';
import S from './JoinAdwile.module.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const JoinAdwile: FC = () => {
  const { t } = useTranslation();

  const isMobile = useMedia('only screen and (max-width: 743px)', false);

  return (
    <section className={S.JoinAdwile}>
      <Container>
        <BlockHeader
          block={t('webmaster.join_adwile_section.title')}
          title={
            <span className={S.Title}>
              {t('webmaster.join_adwile_section.subtitle')}
            </span>
          }
          whiteText
          noTopMargin
        />
        <div className={S.Action}>
          {isMobile ? (
            <>
              <Button size="large" stretch={isMobile}>
                {t('webmaster.join_adwile_section.button_mobile_1')}
              </Button>
              <Button size="large" theme="dark" stretch={isMobile}>
                {t('webmaster.join_adwile_section.button_mobile_2')}
              </Button>
            </>
          ) : (
            <Link to="/sign-up/webmaster">
              <Button size="large">
                {t('webmaster.join_adwile_section.button')}
              </Button>
            </Link>
          )}
        </div>
      </Container>
    </section>
  );
};
